<template>
  <div class="layout-notification-container" v-if="newNotificationList.length">
    <div
      class="layout-notification"
      v-for="item in newNotificationList"
      :key="item.id"
    >
      <button class="close" @click="deleteNotification(item.id)">
        <img src="@/assets/icons/close.svg" alt="" />
      </button>
      <div class="row">
        <div class="col-2">
          <img src="@/assets/icons/white-pill.svg" />
        </div>
        <div class="col-10">
          <p class="text-right text-white mb-0">
            <span>
              {{ item.title }}
            </span>
            <br />
            <span>
              {{ item.content }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as signalR from "@microsoft/signalr";
import { getToken } from "@/utils/auth";

export default {
 data: () => {
    return {
      newNotificationList: [],
      token: getToken(),
    };
  },
  mounted() {
    // setTimeout(this.openNotificationChannel(), 1000);
    // this.openNotificationChannel();
  },
  methods: {
    openNotificationChannel() {
      //start notification
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_SECURITY_URL}notificationsHub`, {
          accessTokenFactory: () => getToken(),
          headers: {
            Authorization: "Bearer " + getToken(),
          },
        })
        .withAutomaticReconnect([0, 0, 10000])
        .configureLogging(signalR.LogLevel.Information)
        .build();

      connection.start();
      connection.serverTimeoutInMilliseconds = 1000 * 60 * 10;
      connection.keepAliveIntervalInMilliseconds = 1000 * 60 * 10;

      connection.onclose(() => {
        setTimeout(() => connection.start(), 5000);
      });

      connection.on("notificationHandler", (newNotification) => {
        this.newNotificationList.push(newNotification);
        this.$store.commit("notification/initHeaderNotification", true);
        setTimeout(() => {
          this.deleteNotification(newNotification.id);
          this.$store.commit("notification/initHeaderNotification", false);
        }, 4000);
      });
    },
    deleteNotification(id) {
      const index = this.newNotificationList.findIndex(
        (obj) => obj.notificationId === id
      );
      this.newNotificationList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "_style.scss";
</style>
